import api from '../../../config/axios-interceptor';

const buildStartDateParams = (startDate) => {
    if (!startDate) return {};
    return {startDate};
};

/* --------------------------
 * 1) Total Chats
 * -------------------------- */
export const getTotalChats = async (startDate) => {
    try {
        const params = buildStartDateParams(startDate);
        return await api.get('/api/v1/admin/dashboard/total-chats', {params});
    } catch (error) {
        console.error('❌ Error fetching total chats:', error);
        throw error;
    }
};

/* --------------------------
 * 2) Open Chats
 * -------------------------- */
export const getOpenChats = async (startDate) => {
    try {
        const params = buildStartDateParams(startDate);
        return await api.get('/api/v1/admin/dashboard/open-chats', {params});
    } catch (error) {
        console.error('❌ Error fetching open chats:', error);
        throw error;
    }
};

/* --------------------------
 * 3) Closed Chats
 * -------------------------- */
export const getClosedChats = async (startDate) => {
    try {
        const params = buildStartDateParams(startDate);
        return await api.get('/api/v1/admin/dashboard/closed-chats', {params});
    } catch (error) {
        console.error('❌ Error fetching closed chats:', error);
        throw error;
    }
};

/* --------------------------
 * 4) Chats By Day
 * -------------------------- */
export const getChatsByDay = async (startDate) => {
    try {
        const params = buildStartDateParams(startDate);
        return await api.get('/api/v1/admin/dashboard/chats-by-day', {params});
    } catch (error) {
        console.error('❌ Error fetching chats by day:', error);
        throw error;
    }
};

/* --------------------------
 * 5) Average Wait Time
 * -------------------------- */
export const getAverageWaitTime = async (startDate) => {
    try {
        const params = buildStartDateParams(startDate);
        return await api.get('/api/v1/admin/dashboard/average-wait-time', {params});
    } catch (error) {
        console.error('❌ Error fetching average wait time:', error);
        throw error;
    }
};

/* --------------------------
 * 6) Average Satisfaction
 * -------------------------- */
export const getAverageSatisfaction = async (startDate) => {
    try {
        const params = buildStartDateParams(startDate);
        return await api.get('/api/v1/admin/dashboard/average-satisfaction', {params});
    } catch (error) {
        console.error('❌ Error fetching average satisfaction:', error);
        throw error;
    }
};

/* --------------------------
 * 7) Top Operators
 * -------------------------- */
export const getTopOperators = async () => {
    try {
        return await api.get('/api/v1/admin/dashboard/top-operators');
    } catch (error) {
        console.error('❌ Error fetching top operators:', error);
        throw error;
    }
};

/* --------------------------
 * 8) Live Snapshot — وضعیت «همین الان» صف‌ها (بدون پارامتر، فقط خواندنی)
 * کارت‌های بالای داشبورد ادمین از این می‌خوانند؛ کارت‌های ۷ روزه روند تاریخی‌اند و
 * برای تصمیمِ لحظه‌ای («الان چند نفر بی‌اپراتور منتظرند؟») به‌درد نمی‌خورند.
 * -------------------------- */
export const getLiveSnapshot = async () => {
    try {
        return await api.get('/api/v1/admin/dashboard/live-snapshot');
    } catch (error) {
        console.error('❌ Error fetching live snapshot:', error);
        throw error;
    }
};

/* --------------------------
 * 9) Live Operators — بار لحظه‌ای هر اپراتور (شامل اپراتورهایی که هیچ امتیازی ندارند)
 * -------------------------- */
export const getLiveOperators = async () => {
    try {
        return await api.get('/api/v1/admin/dashboard/live-operators');
    } catch (error) {
        console.error('❌ Error fetching live operators:', error);
        throw error;
    }
};
